import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {QueryClient} from '@tanstack/react-query';

// translations
import frenchTranslation from './fr/translation.json';
import englishTranslation from './en/translation.json';

// services
import PreferenceManager from '../services/PreferenceManager/PreferenceManager';
import {CreditBookApi} from '../services/ApiService';

const supportedLanguages = ['fr', 'en'];

export const LANGUAGES = {
  fr: {
    translation: frenchTranslation,
  },
  en: {
    translation: englishTranslation,
  },
};

/**
 * Change the language of the app, of the api and refetch all queries.
 * Save the language in local storage.
 * @param language
 * @param queryClient
 */
export const changeLanguage = async (
  language: 'fr' | 'en',
  queryClient: QueryClient,
) => {
  CreditBookApi.setLanguage(language);
  await i18n.changeLanguage(language);
  PreferenceManager.setLanguage(language);
  await queryClient.refetchQueries();
};

/**
 * Determine the initial language of the app.
 * @return the initial language of the app
 */
const initLanguage = () => {
  // If there is a preference language, use it
  const preference = PreferenceManager.getPreference();
  const preferenceLanguage = preference?.language;

  if (preferenceLanguage && supportedLanguages.includes(preferenceLanguage)) {
    return preferenceLanguage;
  }

  // Otherwise, if the browser language is supported, use it
  const browserLanguage = navigator.language.slice(0, 2);

  if (supportedLanguages.includes(browserLanguage)) {
    return browserLanguage;
  }

  // English is the default language
  return 'en';
};

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  lng: initLanguage(),
  fallbackLng: supportedLanguages[0],
  supportedLngs: supportedLanguages,
  resources: LANGUAGES,
  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false,
  },
  defaultNS: 'translation',
});

export default i18n;
